import { useState, useEffect } from 'react';
import { positionSchema } from '../utils/data';
import { btnOne, subTitle, title } from '../utils/style';
import { Link } from 'react-router-dom';
import Table from '../reusable_components/Table';
import { url } from '../utils/config';
import Button from '../reusable_components/Button';

function Position() {
    const [ positionData, setPositionData ] = useState(positionSchema);

    const options = [
        {
            header: 'Department',
            key: 'department',
        },
        {
            header: 'Role',
            key: 'role',
        },
        {
            header: 'Vacancy Date',
            key: 'vacancyDate',
        },
        {
            header: 'Posting Link',
            key: 'postingLink',
        },
        {
            header: 'Approver',
            key: 'approver',
        },
        {
            header: 'Position History',
            key: 'positionHistory',
        },
        {
            header: 'Vacancy Reason',
            key: 'vacancyReason',
        },
    ]

    return(
        <div className='flex flex-col w-full'>
            <div className='flex justify-between items-center pb-4'>
                <div className={title}>Open Positions</div>
                <span>
                    <Button 
                        className={btnOne}
                        name={<Link to={'/employee'}>Employee</Link>}
                    />
                </span>
            </div>

            <Table
                url={url + '/'}
                options={options}
                pagination
                btnTitle={'Open Position'}
            />
        </div>
    )

}

export default Position;